import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { EnvelopeSimple, ChatText } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VERB = { email: 'Emailed', sms: 'Texted' };
const ICON = { email: EnvelopeSimple, sms: ChatText };

// "Emailed Maria · Texted Maria" log for a task (desktop only, hidden on phones)
export const TaskMessageHistory = ({ taskId, refreshKey }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/tasks/${taskId}/contact-messages`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [taskId, refreshKey]);

  if (items.length === 0) return null;
  return (
    <div className="hidden lg:block mobile-card p-6 mb-4" data-testid="task-message-history">
      <h3 className="font-display text-base font-semibold text-gray-900 mb-3">Messages sent</h3>
      <ul className="space-y-2">
        {items.map((m) => (
          <li key={m.id} className="flex items-start justify-between gap-4 text-sm" title={m.message_preview || ''} data-testid={`task-message-${m.id}`}>
            <span className="flex flex-wrap items-center gap-x-1.5 text-gray-800">
              {m.channels.map((ch, i) => {
                const Icon = ICON[ch];
                return (
                  <React.Fragment key={ch}>
                    {i > 0 && <span className="text-gray-300">·</span>}
                    <span className="inline-flex items-center gap-1"><Icon size={14} className="text-indigo-500" />{VERB[ch]} {m.contact_name}</span>
                  </React.Fragment>
                );
              })}
            </span>
            <span className="text-xs text-gray-500 whitespace-nowrap">
              {m.created_at ? new Date(m.created_at).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TaskMessageHistory;
